import {Injectable} from '@angular/core';
import {ApiService} from '@common-lib';
import {map} from 'rxjs/operators';

@Injectable()
export class PluginGotenehusMappingService {

    constructor(private api: ApiService) {
    }

    getList() {
        return this.api.get('/admin/plugin-gotenehus/mappings').pipe(map(({result}) => result));
    }

    update(id : number, value) {
        if (id) {
            return this.api.put('/admin/plugin-gotenehus/mapping/' +id, value).pipe(map(({result}) => result));
        }
    }

    create(value) {
        return this.api.post('/admin/plugin-gotenehus/mapping', value).pipe(map(({result}) => result));
    }


    delete(row) {
        if (row) {
            return this.api.delete('/admin/plugin-gotenehus/mapping/' + row.id).pipe(map(response => response));
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/pages-services/plugin-gotenehus-mapping.service.ts